import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Duplicate.svg?component
var Duplicate_exports = /* @__PURE__ */ __exportAll({
	default: () => Duplicate_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M7.42 16.58H3.25a.83.83 0 0 1-.83-.83V3.25a.83.83 0 0 1 .83-.83h12.5a.83.83 0 0 1 .83.83v4.17"
	}, null, -1), createElementVNode("path", {
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M8.25 7.42h12.5s.83 0 .83.83v12.5s0 .83-.83.83H8.25s-.83 0-.83-.83V8.25s0-.83.83-.83"
	}, null, -1)])]);
}
var Duplicate_default = { render: render$1 };
//#endregion
export { Duplicate_exports, Duplicate_default as default, render$1 as render };

//# sourceMappingURL=Duplicate.svg.virtual.js.map